module.exports = __webpack_public_path__ + "static/media/PG.db2064bb.png";